import { useTranslation } from 'react-i18next';

import stopIcon from 'src/assets/icons/stop.svg';

import { I18NextNS } from 'src/models/Language.model';

import InfoCardTemplate from './InfoCardTemplate';

export default function MaxAttemptInfoCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.infoCards.maxAttempt',
  });

  return (
    <InfoCardTemplate
      icon={<img src={stopIcon} alt="Stop" />}
      backgroundColor="danger-100"
      borderColor="danger"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="info-max-attempt"
    />
  );
}
